var stickers = [
    {
        s: '.hero-wrap .a1',
        p: 'lo'
    },
    {
        s: '.hero-wrap .a2',
        p: 'ru'
    },
    {
        s: '#shopify-section-template--23634778620241__multicolumn_ibbFUp .media',
        p: 'ro',
        m: 'smile_w'
    },
    {
        s: '#shopify-section-template--23634778620241__multicolumn_ibbFUp .media',
        p: 'lu',
        m: 'smile_w',
        o: 'visible'
    },
    {
        s: '#shopify-section-template--23634778620241__anju-bilder .right .image',
        p: 'ro',
    },
    {
        s: '.collection-hero__title',
        p: 'ro'
    },
    {
        s: '.product .product__description',
        p: 'ro'
    }
];

var motives = {
    'heart_a': 'https://cdn.shopify.com/s/files/1/0842/7005/5761/files/heart-a.svg?v=1728915346',
    'heart_o': 'https://cdn.shopify.com/s/files/1/0842/7005/5761/files/heart-o.svg?v=1728915345',
    'heart_l': 'https://cdn.shopify.com/s/files/1/0842/7005/5761/files/heart-l.svg?v=1728915345',
    'smile_o': 'https://cdn.shopify.com/s/files/1/0842/7005/5761/files/smile-o.svg?v=1728915345',
    'smile_w': 'https://cdn.shopify.com/s/files/1/0842/7005/5761/files/smile-w_2090da79-235c-4f16-a074-8f09f36bab00.svg?v=1729079592'
}

window.addEventListener('load',function() {
    
    stickers.forEach(function(sticker) {
        var el = document.querySelector(sticker.s);
        console.log(el);
        if(el) {
            var p = sticker.p;
            var imgspan = document.createElement('span');
            imgspan.classList.add('anjusticker');
            imgspan.classList.add(p);
            var img = document.createElement('img');
            img.src = motives[sticker.m?sticker.m:'smile_o'];
            var plusminus1 = Math.random() < 0.5 ? -1 : 1;
            img.style = 'transform: rotate('+Math.floor(Math.random() * plusminus1 * 5)+'deg);';
            imgspan.appendChild(img);
            var style = window.getComputedStyle(el);
            console.log(style.position);
            if(style.position != 'absolute' && style.position != 'relative') {
                el.style.position = 'relative';
            }
            if(sticker.o) {
                el.style.overflow = sticker.o;
            }
            el.appendChild(imgspan);
        } else {
            console.log('Element not found: '+sticker.s);
        }
    });

    this.document.querySelector('.product__manufacturer').addEventListener('click', function() {
        this.querySelector('div').classList.toggle('show');
    });

})